import store from "@/state/store";

export function isEnforcePendingAuthorizationEnabled() {
  if (!store.getters["settings/enforceAuthorizationLoaded"]) {
    return true;
  }
  return store.getters["settings/isEnforcePendingAuthorizationEnabled"];
}
